import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 text-center mt-auto">
      <div className="container mx-auto flex flex-col md:flex-row justify-center items-center gap-4">
        <p className="text-sm">&copy; {new Date().getFullYear()} PixArt Play. Todos los derechos reservados.</p>
        <div className="flex gap-4">
          <Link to="/politica-de-privacidad" className="text-sm hover:text-blue-400 transition-colors">
            Política de Privacidad
          </Link>
          <Link to="/terminos-uso" className="text-sm hover:text-blue-400 transition-colors">
            Términos de Uso
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
